import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CmsserviceService } from "src/app/common-cms-service/cmsservice.service";


interface FaqItem {
  question: string;
  answer: string;
  answerHtml?: string;
  isOpen: boolean;
}

@Component({
    templateUrl: './uae.component.html',
    styleUrls: ['./uae.component.css'],
    standalone: false
})
export class UAEComponent implements OnInit {

  slug: string;
  pagetitle: string;
  fields = [];
  ngUnsubscribe = new Subject<void>();

whyChooseItems = [
    {
      number: '01',
      title: 'UK-Qualified Tutors',
      description: ''
    },
    {
      number: '02',
      title: '1-2-1 & Group Clasess',
      description: ''
    },
    {
      number: '03',
      title: 'Proven Results (98% A*-B Grades)',
      description: ''
    },
    {
      number: '04',
      title: 'UAE-Focused Schedules & Curriculum',
      description: ''
    }
  ];

  values = [
    {
      icon: '🏆',
      title: 'Excellence',
      description: 'We aim for outstanding outcomes.'
    },
    {
      icon: '🤝',
      title: 'Integrity',
      description: 'Honest feedback, realistic goals.'
    },
    {
      icon: '👤',
      title: 'Care',
      description: 'Every student is unique.'
    },
    {
      icon: '📊',
      title: 'Results',
      description: 'Success measured by growth and confidence.'
    },
    {
      icon: '💡',
      title: 'Innovation',
      description: 'Smart tech, real human connection.'
    }
  ];

  courses = [
    {
      icon: 'atom',
      title: 'IGCSE (Years 7-13)',
      subjects: 'Mathematics | English | Physics | Chemistry | Biology | Business | Economics | ICT and more'
    },
    {
      icon: 'atom',
      title: 'IB & IBDP (Years 7-13)',
      subjects: 'Standard Level (SL) & Higher Level (HL). Extended Essay & TOK guidance, and exam-focused revision'
    },
     {
      icon: 'atom',
      title: 'CBSE (Grades 7-12)',
      subjects: 'Full curriculum support with India specialists with CBSE board mastery'
    },
  ];

  learningSteps = [
    {
      step: '1',
      title: 'Free Trial Consultation',
      description: 'Discuss goals & challenges'
    },
    {
      step: '2',
      title: 'Diagnostic Assessment',
      description: 'Identify strengths, identify gaps (core subjects like Maths & English )'
    },
    {
      step: '3',
      title: 'Personalised Study Plan',
      description: 'Tailored timeline to success'
    },
    {
      step: '4',
      title: 'Live 1-on-1 Tuition',
      description: 'Choose your perfect slot with our tutor pool'
    },
    {
      step: '5',
      title: 'Flex Trial Tutoring',
      description: 'Experience our teaching style!'
    },
    {
      step: '6',
      title: 'Mock Tests',
      description: 'Build exam confidence'
    },
    {
      step: '7',
      title: 'Progress Tracking',
      description: 'Transparent reports and celebrations'
    }
  ];

  foundingBatchFeatures = [
    {
      icon: 'desktop',
      title: 'Free Trial Class',
      bgColor: '#E3F2FD'
    },
    {
      icon: 'medal',
      title: 'Founding Student Rewards',
      bgColor: '#FFF3E0'
    },
    {
      icon: 'users',
      title: 'Personal Learning Assistance Team & Life Coaching (Included)',
      bgColor: '#F3E5F5'
    }
  ];

  constructor( private router: Router, private cmsService: CmsserviceService, private titleService: Title) {}

  ngOnInit(): void {
    this.slug = this.router.url;
    this.onLoad();
  }

  onLoad() {
    $('.loader-bg').fadeIn();
    const pageName = this.slug.split('/')[(this.slug.split('/').length - 1)];
    this.cmsService.getCmsData(pageName)
    .pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
    this.pagetitle = res.data.page_title;
    this.fields = res.data.fields;
    this.titleService.setTitle(this.pagetitle);
    $('.loader-bg').fadeOut();
});
}

  bookDemo() {
     window.location.href =
      "https://zfrmz.in/F8xQwAcqcCjms2xc0q1s";
  }

  scrollToSection(section: string) {
    console.log('Scroll to:', section);
    // Add scroll logic here
  }

  startFreeTrial() {
    console.log('Start free trial clicked');
    // Add your trial logic here
  }

  readMoreResults() {
    console.log('Read more results clicked');
    // Add navigation logic here
  }

  getStarted() {
    console.log('Get started clicked');
    // Add get started logic here
  }

  joinFoundingBatch() {
    console.log('Join founding batch clicked');
    // Add join logic here
  }

  
  faqs: FaqItem[] = [
    {
      question: '1. How does online tutoring work?',
      answer: 'Our online tutoring takes place via secure Zoom sessions with professional tutors. Students receive a personalized link, join at the scheduled time, and engage in interactive one-on-one or small group lessons. All sessions can be recorded for revision purposes.',
      isOpen: true
    },
    {
      question: '2. Which examination boards do you cover?',
      answerHtml: '<p>We specialize in:</p><ul><li>IGCSE: Cambridge International (CIE) & Pearson Edexcel International GCSE</li><li>CBSE: Central Board of Secondary Education (Indian curriculum)</li><li>IB: International Baccalaureate MYP and Diploma Programme</li></ul>',
      answer: '',
      isOpen: false
    },
    {
      question: '3. Who are your tutors?',
      answerHtml: '<p>All Sehyog tutors are UK-qualified educators with:</p><ul><li>Qualified Teacher Status (QTS) or equivalent teaching credentials</li><li>Minimum 5 years of curriculum-specific teaching experience</li><li>Enhanced DBS (background) checks</li><li>Specialized training in online pedagogy</li><li>Native or near-native English proficiency</li></ul>',
      answer: '',
      isOpen: false
    },
    {
      question: '4. What if my child and the tutor aren\'t a good match?',
      answer: 'We offer a free trial lesson specifically to ensure compatibility. If after regular sessions begin you feel the tutor isn\'t the right fit, we will arrange an alternative tutor at no additional cost. Your child\'s comfort and learning success are our priorities.',
      isOpen: false
    },
    {
      question: '5. How quickly will I see results?',
      answer: 'Most students show measurable improvement within 6-8 weeks of consistent tutoring. However, results depend on starting point, frequency of sessions, student effort, and specific goals. We provide regular progress updates through our RAR system.',
      isOpen: false
    },
    {
      question: '6. What is your cancellation policy?',
      answer: 'We offer free cancellation or rescheduling up to 24 hours before a scheduled lesson (48 hours for Premium Tutoring). Cancellations within this window may be charged at 50% of the lesson fee.',
      isOpen: false
    },
    {
      question: '7. Do you offer group tutoring?',
      answer: 'Yes! We offer small group sessions (2-4 students) at reduced rates for students studying the same curriculum and subject. This is ideal for siblings or friends preparing together.',
      isOpen: false
    },
    {
      question: '8. Is there a minimum commitment?',
      answer: 'No. While we recommend regular weekly sessions for best results, there is no minimum term commitment. You can book lessons flexibly and pause or resume as needed.',
      isOpen: false
    },
    {
      question: '9. How do I track my child\'s progress?',
      answer: 'Parents and students have 24/7 access to our Student Dashboard and Result Analysis Report (RAR) system, which provides detailed insights into attendance, homework completion, assessment scores, and learning trends.',
      isOpen: false
    },
    {
      question: '10. What is included in the free consultation?',
      answerHtml: '<p>The free consultation includes:</p><ul><li>Discussion of academic goals and challenges</li><li>Curriculum and subject coverage review</li><li>Learning style assessment</li><li>Customized study plan recommendation</li><li>Tutor matching and scheduling options</li><li>No obligation to enroll</li></ul>',
      answer: '',
      isOpen: false
    },
    {
      question: '11. Do you offer a money-back guarantee if I\'m not satisfied after starting?',
      answer: 'Yes! We stand behind the quality of our teaching. If after your first week of regular classes (up to 4 lessons) you\'re not completely satisfied with the tutoring experience, we offer a full refund—no questions asked. This gives you peace of mind to try our service risk-free. We\'re confident in our tutors and methodology, and we want you to feel the same confidence in choosing Sehyog for your child\'s education.',
      isOpen: false
    }
  ];

  // This is the Angular equivalent of your JavaScript code
  toggleFaq(clickedIndex: number): void {
    const isCurrentlyOpen = this.faqs[clickedIndex].isOpen;
    
    // Close all items (equivalent to removing 'active' class from all)
    this.faqs.forEach((faq) => {
      faq.isOpen = false;
    });
    
    // Open clicked item if it wasn't active
    if (!isCurrentlyOpen) {
      this.faqs[clickedIndex].isOpen = true;
    }
  }


   activeTab: string = 'igcse';

  selectTab(tabId: string): void {
    this.activeTab = tabId;
  }

  isActiveTab(tabId: string): boolean {
    return this.activeTab === tabId;
  }


}
